import React, { useEffect } from 'react';
import { Divider, TextField, Grid, Typography, Button, FormControl } from '@mui/material';
import { useState } from 'react';
import { get, useForm } from 'react-hook-form';
import { RoleAddRequest, RoleRequest } from 'src/models/roles';
import { object, string } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import BuildIcon from '@mui/icons-material/Build';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import TabOne from './components/TabOne';
import TabTwo from './components/TabTwo';
import TabThree from './components/TabThree';
import TabFour from './components/TabFour';
import {
  createRole,
  getFieldsByType,
  getPermissionByType
} from 'src/services/RoleManagementService';
import { AppActions } from 'src/store/AppReducer';
import { useDispatch } from 'react-redux';
import TabFive from './components/TabFive';
import { DatePicker } from '@mui/lab';
import moment from 'moment';
import TabNine from './components/TabNine';
import TabTen from './components/TabTen';
import TabEleven from './components/TabEleven';
import TabTwelve from './components/TabTwelve';
import TabThirteen from './components/TabThirteen';
import TabFourteen from './components/TabFourteen';
import TabFifteen from './components/TabFifteen';

const AddForm = ({ LabelStyle, TextFieldStyle, onClose, getData }) => {
  const dispatch = useDispatch();
  const [tabvalue, setTabValue] = useState('one');

  const addRoleSchema = object({
    roleName: string()
      .trim()
      .min(1, { message: 'Role name is required' })
      .max(30, 'Name must be less than 30 characters'),
    startDate: string().nonempty('Start Date is required'),
    endDate: string().optional()
  });

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors }
  } = useForm<RoleAddRequest>({
    resolver: zodResolver(addRoleSchema) as any
  });

  const handleClose = () => {
    onClose();
    reset();
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const [dashboardData, setdashboardData] = useState([]);
  const [commonPermissions, setcommonPermissions] = useState([]);
  const [generalDetails, setgeneralDetails] = useState([]);
  const [contactDetails, setcontactDetails] = useState([]);
  const [employementDetails, setEmployementDetails] = useState([]);
  const [bankingDetails, setBankingDetails] = useState([]);
  const [commonPermissionsProject, setcommonPermissionsProject] = useState([]);
  const [generalDetailsProject, setgeneralDetailsProject] = useState([]);
  const [FinancialDetails, setFinancialDetails] = useState([]);
  const [timeEstimations, setTimeEstimations] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);
  const [leaveManagementData, setLeaveManagementData] = useState([]);
  const [workModelData, setWorkModelData] = useState([]);
  const [workFromHomeData, setWorkFromHomeData] = useState([]);
  const [timesheetData, setTimesheetData] = useState([]);
  const [taskAssignmentData, setTaskAssignmentData] = useState([]);
  const [timeEntryData, setTimeEntryData] = useState([]);
  const [resourcePoolData, setResourcePoolData] = useState([]);
  const [detailReport, setDetailReport] = useState([]);
  const [summarizedReport, setSummarizedReport] = useState([]);
  const [taskBasedReport, setTaskBasedReport] = useState([]);
  const [feedbackData, setFeedbackData] = useState([]);
  const [varianceReport, setVarianceReport] = useState([]);
  const [employeeTimesheetData, setEmployeeTimesheetData] = useState([]);
  const [eventManagementData, setEventManagementData] = useState([]);
  const [employeeOnboardingData, setEmployeeOnboardingData] = useState([]);
  const [onboardingToDoListData, setOnboardingToDoListData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);

  const [others, setOthers] = useState([]);
  const [othersEdit, setOthersEdit] = useState([]);
  const [isStartDateError, setIsStartDateError] = useState<boolean>(true);
  const [dateError, setDateError] = useState('');

  const [shouldDisabled, setShouldDisabled] = useState(false);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
   const [designationsData, setDesignationsData] = useState([]);

  useEffect(() => {
    if (
      !commonPermissions?.filter((comm) => comm?.name === 'Edit')[0]?.value &&
      generalDetails.length > 0 &&
      contactDetails.length > 0 &&
      bankingDetails.length > 0 &&
      employementDetails.length > 0
    ) {
      onClickAll(generalDetails, 'edit', setgeneralDetails, false);
      onClickAll(contactDetails, 'edit', setcontactDetails, false);
      onClickAll(bankingDetails, 'edit', setBankingDetails, false);
      onClickAll(employementDetails, 'edit', setEmployementDetails, false);
    }
  }, [commonPermissions]);

  useEffect(() => {
    if (
      !commonPermissionsProject?.filter((comm) => comm?.name === 'Edit')[0]
        ?.value &&
      generalDetailsProject.length > 0 &&
      stakeholders.length > 0 &&
      FinancialDetails.length > 0 &&
      timeEstimations.length > 0
    ) {
      onClickAll(
        generalDetailsProject,
        'edit',
        setgeneralDetailsProject,
        false
      );
      onClickAll(stakeholders, 'edit', setStakeholders, false);
      onClickAll(FinancialDetails, 'edit', setFinancialDetails, false);
      onClickAll(timeEstimations, 'edit', setTimeEstimations, false);
    }
  }, [commonPermissionsProject]);

  useEffect(() => {
    const allPermsAndFields = [
      ...dashboardData,
      ...leaveManagementData,
      ...workModelData,
      ...workFromHomeData,
      ...timesheetData,
      ...taskAssignmentData,
      ...timeEntryData,
      ...detailReport,
      ...summarizedReport,
      ...taskBasedReport,
      ...resourcePoolData,
      ...generalDetails,
      ...contactDetails,
      ...employementDetails,
      ...bankingDetails,
      ...generalDetailsProject,
      ...FinancialDetails,
      ...timeEstimations,
      ...stakeholders,
      ...commonPermissions,
      ...commonPermissionsProject,
      ...others,
      ...othersEdit,
      ...varianceReport,
      ...employeeTimesheetData,
      ...eventManagementData,
      ...designationsData,
      ...employeeOnboardingData,
      ...onboardingToDoListData,
      ...attendanceData
    ];

    if (allPermsAndFields?.length > 0) {
      const filteredPermsFields = allPermsAndFields.filter(
        (fil) =>
          fil.name !== 'Name' &&
          fil.name !== 'Name in Jira' && 
          fil.name !== 'Gender' &&
          (fil.value || fil.edit || fil.view)
      );
      const filteredEditPermsFields = allPermsAndFields.filter(
        (fil) => fil.edit
      );
      if (
        filteredPermsFields?.length > 0 ||
        filteredEditPermsFields?.length > 0
      ) {
        setShouldDisabled(true);
      } else if (
        filteredPermsFields?.length === 0 &&
        filteredEditPermsFields?.length === 0
      ) {
        setShouldDisabled(false);
      }
    }
  }, [
    FinancialDetails,
    bankingDetails,
    commonPermissions,
    commonPermissionsProject,
    contactDetails,
    dashboardData,
    leaveManagementData,
    workModelData,
    timesheetData,
    taskAssignmentData,
    timeEntryData,
    detailReport,
    summarizedReport,
    taskBasedReport,
    workFromHomeData,
    resourcePoolData,
    employementDetails,
    generalDetails,
    generalDetailsProject,
    others,
    othersEdit,
    stakeholders,
    timeEstimations,
    varianceReport,
    employeeTimesheetData,
    eventManagementData,
    designationsData,
    employeeOnboardingData,
    onboardingToDoListData,
    attendanceData
  ]);

  const getFields = async () => {
    getFieldsByType('Dashboard').then((res) => {
      setdashboardData(res.data);
    });
    getFieldsByType('Employee').then((res) => {
      const data = res.data;
      const generalDetailsFilter = data.filter(
        (ele) => ele.category === 'General'
      );
      const generalDetailsChecked = generalDetailsFilter.map((ele) => {
        if (ele.name === 'Name in Jira' || ele.name === 'Name' || ele.name === 'Gender') {
          return {
            id: ele.id,
            name: ele.name,
            tab: ele.tab,
            category: ele.category,
            view: true,
            edit: ele.edit
          };
        } else return ele;
      });
      const contactDetailsFilter = data.filter(
        (ele) => ele.category === 'Contact'
      );
      const EmployementDetailsFilter = data.filter(
        (ele) => ele.category === 'Employment'
      );
      const BankingDetailsFilter = data.filter(
        (ele) => ele.category === 'Finance'
      );

      setgeneralDetails(generalDetailsChecked);
      setcontactDetails(contactDetailsFilter);
      setEmployementDetails(EmployementDetailsFilter);
      setBankingDetails(BankingDetailsFilter);
    });
    getFieldsByType('Project').then((res) => {
      const data = res.data;

      const generalDetailsFilter = data.filter(
        (ele) => ele.category === 'General'
      );
      const financialDetailsFilter = data.filter(
        (ele) => ele.category === 'Financial'
      );
      const TimeEstimationsFilter = data.filter(
        (ele) => ele.category === 'Time Estimation'
      );
      const StakeholdersFilter = data.filter(
        (ele) => ele.category === 'Stakeholders'
      );
      setgeneralDetailsProject(generalDetailsFilter);
      setFinancialDetails(financialDetailsFilter);
      setTimeEstimations(TimeEstimationsFilter);
      setStakeholders(StakeholdersFilter);
    });
    getPermissionByType('Employee').then((res) => {
      setcommonPermissions(res.data);
    });
    getPermissionByType('Project').then((res) => {
      setcommonPermissionsProject(res.data);
    });
    getPermissionByType('Leave Management').then((res) => {
      setLeaveManagementData(res.data);
    });
    getPermissionByType('Work Model').then((res) => {
      setWorkModelData(res.data);
    });
    getPermissionByType('Work From Home').then((res) => {
      setWorkFromHomeData(res.data);
    });
    getPermissionByType('Resource Pool').then((res) => {
      setResourcePoolData(res.data);
    });

    getPermissionByType('Feedback').then((res) => {
      setFeedbackData(res.data);
    });
    getPermissionByType('Activity Management').then((res) => {
      setTimesheetData(res.data);
    });
    getPermissionByType('Task Assignment').then((res) => {
      setTaskAssignmentData(res.data);
    });
    getPermissionByType('Time Entry').then((res) => {
      setTimeEntryData(res.data);
    });
    getPermissionByType('Detailed Report').then((res) => {
      setDetailReport(res.data);
    });
    getPermissionByType('Summarized Report').then((res) => {
      setSummarizedReport(res.data);
    });
    getPermissionByType('Task Based Report').then((res) => {
      setTaskBasedReport(res.data);
    });

    getPermissionByType('Variance Report').then((res) => {
      setVarianceReport(res.data);
    });
    
    getPermissionByType('Employee Timesheet').then((res) => {
      setEmployeeTimesheetData(res.data);
    });

    getPermissionByType('Event Management').then((res) => {
      setEventManagementData(res.data);
    });
    getPermissionByType('Designations').then((res) => {
      setDesignationsData(res.data);
    });
    getPermissionByType('Employee Onboarding').then((res) => {
      setEmployeeOnboardingData(res.data);
    });
    getPermissionByType('Onboarding To Do List').then((res) => {
      setOnboardingToDoListData(res.data);
    });
    getPermissionByType('Attendance').then((res) => {
      const permissions = (Array.isArray(res?.data) ? res.data : []).filter(
        (item) =>
          !['my attendance', 'employee attendance'].includes(
            String(item?.name || '').trim().toLowerCase()
          )
      );
      const defaults = [
        {
          id: 'view-employee-attendance',
          name: 'View Employee Attendance',
          tab: 'Attendance',
          value: false
        },
        { id: 'import-attendance', name: 'Import Attendance', tab: 'Attendance', value: false },
        {
          id: 'download-attendance-report',
          name: 'Download Attendance Report',
          tab: 'Attendance',
          value: false
        },
        {
          id: 'c9e9e617-8ab1-42d8-bd87-9c0e76a18688',
          name: 'View Employee Mapping',
          tab: 'Attendance',
          value: false
        },
        {
          id: 'd062e9b0-0fbd-4384-b748-a12bad3d7470',
          name: 'Add Employee Mapping',
          tab: 'Attendance',
          value: false
        },
        {
          id: '44b69280-7650-4355-8c00-2e13a3e17c8c',
          name: 'Edit Employee Mapping',
          tab: 'Attendance',
          value: false
        },
        {
          id: 'c63ff77a-ad1b-477c-8516-46ff14678669',
          name: 'Remove Employee Mapping',
          tab: 'Attendance',
          value: false
        }
      ];
      const names = new Set(
        permissions.map((item) => String(item?.name || '').trim().toLowerCase())
      );
      setAttendanceData([
        ...permissions,
        ...defaults.filter((item) => !names.has(item.name.toLowerCase()))
      ]);
    });

    const skillData = await getPermissionByType('Skills');
    const healthData = await getPermissionByType('Project Health Summary');
    const resourceData = await getPermissionByType('Resource Management');
    const defineLeavesData = await getPermissionByType('Define Leaves');
    const segmentData = await getPermissionByType('Segments');
    //new name is client, but permission is Customer
    const customers = await getPermissionByType('Customer');
    const stakeholder = await getPermissionByType('Stakeholder');
    const adminData = await getPermissionByType('Configurations');
    const yearPlanData = await getPermissionByType('Year Plan');
    const carryForwardedLeavesData = await getPermissionByType('Carry Forwarded Leaves');
    const downloadAttendanceData = await getPermissionByType('Download Attendance');
    const PreviewEventData = await getPermissionByType('Preview Event');
    const designationTabData = await getPermissionByType('Designations');

    const others = [
      ...skillData?.data,
      ...healthData?.data,
      ...resourceData?.data,
      ...segmentData?.data,
      ...adminData?.data,
      ...customers?.data,
      ...stakeholder?.data,
      ...defineLeavesData?.data,
      ...yearPlanData?.data,
      ...carryForwardedLeavesData?.data,
      ...downloadAttendanceData?.data,
      ...PreviewEventData?.data
    ];

    const filteredEditOthers = others.filter(
      (oth) =>
        oth.name === 'Edit Skills' ||
        oth.name === 'Edit Resources' ||
        oth.name === 'Edit Segments' ||
        oth.name === 'Edit Configurations' ||
        oth.name === 'Edit Customer' ||
        oth.name === 'Edit Stakeholder' || 
        oth.name === 'Edit Define Leaves' ||
        oth.name === 'Edit Year Plan' ||
        oth.name === 'Edit Carry Forwarded Leaves'||
        oth.name === 'Download Attendance'||
        oth.name === 'Preview Event'
    );

    const filteredViewOthers = others.filter(
      (oth) =>
        oth.name !== 'Edit Skills' &&
        oth.name !== 'Edit Resources' &&
        oth.name !== 'Edit Segments' &&
        oth.name !== 'Edit Configurations' &&
        oth.name !== 'Edit Customer' &&
        oth.name !== 'Edit Stakeholder' &&
        oth.name !== 'Edit Define Leaves' &&
        oth.name !== 'Edit Year Plan' &&
        oth.name !== 'Edit Carry Forwarded Leaves' &&
        oth.name !== 'Download Attendance' &&
        oth.name !== 'Preview Event'
    );

    setOthers(filteredViewOthers);
    setOthersEdit(filteredEditOthers);
  };

  useEffect(() => {
    getFields();
  }, []);

  const onClickAll = (array: any, type: string, setArray: any, e?: any) => {
    let changedArray;
    if (array?.length > 0 && type === 'status') {
      changedArray = array.map((arr) => {
        return {
          category: arr.category,
          edit: arr.edit,
          id: arr.id,
          name: arr.name,
          tab: arr.tab,
          view:
            arr.name === 'Name' || arr.name === 'Name in Jira' || arr.name === 'Gender'
              ? true
              : e.target.checked
        };
      });
    }
    if (array?.length > 0 && type === 'common') {
      changedArray = array.map((arr) => {
        return {
          id: arr.id,
          name: arr.name,
          tab: arr.tab,
          value: e.target.checked
        };
      });
    }
    if (array?.length > 0 && type === 'edit') {
      changedArray = array.map((arr) => {
        return {
          category: arr.category,
          edit: e === false ? e : e.target.checked,
          id: arr.id,
          name: arr.name,
          tab: arr.tab,
          view: arr.view
        };
      });
    }
    setArray(changedArray);
  };

  const onSubmit = (data) => {
    const allFieldsArray = [
      ...dashboardData,
      ...generalDetails,
      ...contactDetails,
      ...employementDetails,
      ...bankingDetails,
      ...generalDetailsProject,
      ...FinancialDetails,
      ...timeEstimations,
      ...stakeholders
    ];

    const allPermissionsArray = [
      ...commonPermissions,
      ...commonPermissionsProject,
      ...leaveManagementData,
      ...workModelData,
      ...timesheetData,
      ...taskAssignmentData,
      ...timeEntryData,
      ...detailReport,
      ...summarizedReport,
      ...workFromHomeData,
      ...resourcePoolData,
      ...others,
      ...othersEdit,
      ...taskBasedReport,
      ...varianceReport,
      ...eventManagementData,
      ...designationsData,
      ...employeeOnboardingData,
      ...onboardingToDoListData,
      ...attendanceData
    ];

    const fieldsFilterArray = allFieldsArray.filter(
      (obj) => obj.view || obj.edit
    );
    const permissionsFilterArray = allPermissionsArray.filter(
      (obj) => obj.value
    );

    const removedIds = fieldsFilterArray.filter((ele) => {
      delete ele.id;
      return true;
    });

    const removedIdsPermissions = permissionsFilterArray.filter((ele) => {
      delete ele.id;
      return true;
    });

    if (Date.parse(data.startDate) > Date.parse(data.endDate)) {
      setDateError('End date should be greater than start date');
    } else {
      dispatch(AppActions.showLoader());

      setDateError('');
      const body = {
        name: data.roleName,
        startDate: data.startDate,
        endDate: data.endDate !== '' ? data.endDate : null,
        fieldRequests: [...removedIds],
        permissionRequests: [...removedIdsPermissions]
      };

      createRole(body)
        .then((res) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: "You've created the user role successfully.",
              severity: 'success'
            })
          );
          getData();



          handleClose();
          dispatch(AppActions.hideLoader());
        })
        .catch((e) => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'Unable to add the user role',
              severity: 'error'
            })
          );
          dispatch(AppActions.hideLoader());
        });
    }
  };

  const [role, setrole] = useState('');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid item xs={12} sx={{ pt: 3, pb: 2, pl: 2 }}>
        <Typography style={{ fontSize: '15px' }} variant="h3">
          Create New Role
        </Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Role Name
          </Typography>
          <TextField
            size="small"
            {...register('roleName', {
              required: true,
              maxLength: 30
            })}
            error={!!errors['roleName']}
            helperText={errors['roleName'] ? errors['roleName'].message : ''}
            style={TextFieldStyle}
            fullWidth
            placeholder="Enter Role Name"
            variant="outlined"
            onChange={(e) => {
              setrole(e.target.value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            Start Date
          </Typography>
          <div style={{ marginLeft: 13, marginRight: 13 }}>
            <FormControl fullWidth>
              <DatePicker
                InputProps={{
                  className: 'date-picker'
                }}
                renderInput={(params) => (
                  <TextField {...params} id="startDate" />
                )}
                value={startDate ? startDate : ''}
                onChange={(newValue) => {
                  if (newValue) {
                    setStartDate(moment(newValue).format('YYYY-MM-DD'));
                    setValue(
                      'startDate',
                      moment(newValue).format('YYYY-MM-DD')
                    );
                    setIsStartDateError(false);
                  } else {
                    setIsStartDateError(true);
                  }
                }}
              />
            </FormControl>
            {errors['startDate'] && (
              <>
                {isStartDateError && (
                  <>
                    <div style={{ fontSize: '12px', color: 'red' }}>
                      {'Start Date is required'}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </Grid>
        <Grid item xs={6}>
          <Typography style={LabelStyle} fontWeight="light" variant="h5">
            End Date
          </Typography>
          <div style={{ marginLeft: 15, marginRight: 13 }}>
            <FormControl fullWidth>
              <DatePicker
                disabled={!startDate}
                InputProps={{
                  className: 'date-picker'
                }}
                minDate={new Date(startDate)}
                renderInput={(params) => <TextField {...params} id="endDate" />}
                value={endDate ? endDate : ''}
                onChange={(newValue) => {
                  if (newValue) {
                    setEndDate(moment(newValue).format('YYYY-MM-DD'));
                    setValue('endDate', moment(newValue).format('YYYY-MM-DD'));
                  }
                }}
              />
            </FormControl>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Typography
            style={{ fontSize: '13px' }}
            sx={{ pl: 2, pt: 2, pb: 2 }}
            variant="h4"
          >
            Permissions
          </Typography>
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Box sx={{ pl: 4, pr: 2, pt: 2, pb: 2, width: '100%' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              value={tabvalue}
              onChange={handleChange}
              textColor="primary"
              indicatorColor="primary"
              aria-label="secondary tabs example"
              variant="scrollable"
            >
              <Tab
                id="dashboard-tab"
                style={{ fontSize: '12px' }}
                value="one"
                label="Dashboard"
              />
              <Tab
                id="employees-tab"
                style={{ fontSize: '12px' }}
                value="two"
                label="Employees"
              />
              <Tab
                id="projects-tab"
                style={{ fontSize: '12px' }}
                value="three"
                label="Projects"
              />
              <Tab
                id="leave-management-tab"
                style={{ fontSize: '12px' }}
                value="five"
                label="Leave Management"
              />
              <Tab
                id="resource-pool-tab-edit"
                style={{ fontSize: '12px' }}
                value="six"
                label="Resource Management"
              />
              <Tab
                id="timesheet-add"
                style={{ fontSize: '12px' }}
                value="ten"
                label="Timesheet"
              />
              <Tab
                id="designations-tab"
                style={{ fontSize: '12px' }}
                value="thirteen"
                label="Designations"
              />
               <Tab
                id="feedback"
                style={{ fontSize: '12px' }}
                value="eleven"
                label="Feedback"
              />
              <Tab
                id="event-management-tab"
                style={{ fontSize: '12px' }}
                value="twelve"
                label="Event Management"
              />
              <Tab
                id="employee-onboarding-tab"
                style={{ fontSize: '12px' }}
                value="fourteen"
                label="Employee Onboarding"
              />
              <Tab
                id="attendance-tab"
                style={{ fontSize: '12px' }}
                value="fifteen"
                label="Attendance"
              />
              <Tab
                id="others-tab"
                style={{ fontSize: '12px' }}
                value="four"
                label="Others"
              />
            </Tabs>
          </Box>
          {tabvalue === 'one' && (
            <TabOne
              dashboardData={dashboardData}
              setdashboardData={setdashboardData}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'two' && (
            <TabTwo
              commonPermissions={commonPermissions}
              setcommonPermissions={setcommonPermissions}
              generalDetails={generalDetails}
              setgeneralDetails={setgeneralDetails}
              employementDetails={employementDetails}
              setEmployementDetails={setEmployementDetails}
              bankingDetails={bankingDetails}
              setBankingDetails={setBankingDetails}
              contactDetails={contactDetails}
              setcontactDetails={setcontactDetails}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'three' && (
            <TabThree
              commonPermissionsProject={commonPermissionsProject}
              setcommonPermissionsProject={setcommonPermissionsProject}
              generalDetailsProject={generalDetailsProject}
              setgeneralDetailsProject={setgeneralDetailsProject}
              timeEstimations={timeEstimations}
              stakeholders={stakeholders}
              setTimeEstimations={setTimeEstimations}
              setStakeholders={setStakeholders}
              financialDetails={FinancialDetails}
              setFinancialDetails={setFinancialDetails}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'five' && (
            <TabFive
              leaveManagementData={leaveManagementData}
              setLeaveManagementData={setLeaveManagementData}
              workModelData={workModelData}
              setWorkModelData={setWorkModelData}
              workFromHomeData={workFromHomeData}
              setWorkFromHomeData={setWorkFromHomeData}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'four' && (
            <TabFour
              setOthers={setOthers}
              setOthersEdit={setOthersEdit}
              others={others}
              othersEdit={othersEdit}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'six' && (
            <TabNine
              setOthers={setResourcePoolData}
              others={resourcePoolData}
              onClickAll={onClickAll}
            />
          )}
           {tabvalue === 'ten' && (
            <TabTen
              timesheetData={timesheetData}
              setTimesheetData={setTimesheetData}
              taskAssignmentData={taskAssignmentData}
              setTaskAssignmentData={setTaskAssignmentData}
              employeeTimesheetData={employeeTimesheetData}
              setEmployeeTimesheetData={setEmployeeTimesheetData} 
              timeEntryData={timeEntryData}
              setTimeEntryData={setTimeEntryData}
              detailReport={detailReport}
              setDetailReport={setDetailReport}
              summarizedReport={summarizedReport}
              setSummarizedReport={setSummarizedReport}
              setTaskBasedReport={setTaskBasedReport}
              taskBasedReport={taskBasedReport}
              setVarianceReport={setVarianceReport}
              varianceReport={varianceReport}
              onClickAll={onClickAll}
            />
          )}

            {tabvalue === 'eleven' && (
            <TabEleven
              setOthers={setFeedbackData}
              others={feedbackData}
              onClickAll={onClickAll}
            />
          )}

          {tabvalue === 'twelve' && (
            <TabTwelve
              eventManagementData={eventManagementData}
              setEventManagementData={setEventManagementData}
              onClickAll={onClickAll}
              isEdit={false}
            />
          )}
          {tabvalue === 'thirteen' && (
            <TabThirteen
              setDesignations={setDesignationsData}
              designations={designationsData}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'fourteen' && (
            <TabFourteen
              employeeOnboardingData={employeeOnboardingData}
              setEmployeeOnboardingData={setEmployeeOnboardingData}
              onboardingToDoListData={onboardingToDoListData}
              setOnboardingToDoListData={setOnboardingToDoListData}
              isEdit={false}
              onClickAll={onClickAll}
            />
          )}
          {tabvalue === 'fifteen' && (
            <TabFifteen
              attendanceData={attendanceData}
              setAttendanceData={setAttendanceData}
              isEdit={false}
            />
          )}
        </Box>
      </Grid>
      <Divider sx={{ my: 2 }} />
      <Grid container spacing={2} sx={{ pl: 2 }}>
        <Grid item display={'inline-flex'} xs={6}>
          <Typography
            style={{ display: 'flex', alignItems: 'center' }}
            variant="body2"
          >
            Legends:
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '0.5rem'
              }}
            >
              <BuildIcon
                color="primary"
                sx={{ fontSize: '0.8rem', mr: '0.2rem' }}
              />
              <Typography variant="body2">Edit Access</Typography>
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}
          xs={6}
        >
          <Button
            sx={{
              width: '30%',
              fontWeight: 'normal',
              background: '#F5F7FF',
              fontSize: '13px'
            }}
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={role === '' || !shouldDisabled}
            type="submit"
            sx={{
              width: '30%',
              ml: 3,
              fontSize: '13px',
              fontWeight: 'normal',
              background: '#0069E4'
            }}
            variant="contained"
          >
            Add
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default AddForm;